"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRouterDom = require("react-router-dom");

var _appErrorBoundary = _interopRequireDefault(require("../app-error-boundary"));

var _reactUid = require("react-uid");

const _excluded = ["component"];

/**
 * The Switch component packages up the bits of rendering that are shared between
 * server and client-side. It's *mostly* a react-router Switch component, hence the
 * name.
 *
 * This is for internal use only.
 *
 * @private
 */
const Switch = props => {
  const {
    error,
    appState,
    routes,
    App
  } = props;
  return /*#__PURE__*/_react.default.createElement(_reactUid.UIDReset, null, /*#__PURE__*/_react.default.createElement(_appErrorBoundary.default, {
    error: error
  }, !error && /*#__PURE__*/_react.default.createElement(App, {
    preloadedProps: appState.appProps
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, routes.map((route, i) => {
    const {
      component: Component
    } = route,
          routeProps = (0, _objectWithoutProperties2.default)(route, _excluded);
    return /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, (0, _extends2.default)({
      key: i
    }, routeProps), /*#__PURE__*/_react.default.createElement(_reactUid.UIDFork, null, /*#__PURE__*/_react.default.createElement(Component, {
      preloadedProps: appState.pageProps
    })));
  })))));
};

Switch.propTypes = {
  error: _propTypes.default.object,
  appState: _propTypes.default.object,
  routes: _propTypes.default.array,
  App: _propTypes.default.func,
  preloadedProps: _propTypes.default.object
};
var _default = Switch;
exports.default = _default;